import React, { useCallback, useEffect, useState } from 'react';
import TrueImpactTextfield from 'shared/design-system/components/TrueImpactTextfield';
import { numberWithCommas } from 'shared/utils/numberUtils';

interface ImpactForecastProps {
  isError: boolean;
  isWarning: boolean;
  reportId: number;
  forecast: string;
  disabled?: boolean;
  placeholder: string;
  isFinalForecast: boolean;
  setForecast: React.Dispatch<React.SetStateAction<string>>;
}

const ImpactForecast: React.FC<ImpactForecastProps> = ({
  isError,
  isWarning,
  reportId,
  disabled,
  isFinalForecast,
  forecast,
  placeholder,
  setForecast,
}) => {
  const inputRef = React.useRef<HTMLInputElement>(null);
  const [cursor, setCursor] = useState<number | null>(null);

  useEffect(() => {
    cursor && inputRef.current?.setSelectionRange(cursor, cursor);
  }, [inputRef.current, cursor, forecast]);

  const handleChange = useCallback(
    (
      value: string,
      name?: string,
      e?: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
      if (!e) return;
      const { selectionStart } = e.target;
      const newValue = numberWithCommas(
        parseInt(value.replace(/,/gi, '')) || '',
      );

      setForecast(newValue);
      setCursor(
        value.length === newValue.length - 1
          ? (selectionStart || 0) + 1
          : selectionStart,
      );
    },
    [setForecast, setCursor],
  );

  return (
    <TrueImpactTextfield
      value={forecast}
      disabled={disabled}
      inputRef={inputRef}
      key={isFinalForecast ? 'finalForecast' : 'forecast'}
      id={isFinalForecast ? 'finalForecast' : 'forecast'}
      name={isFinalForecast ? 'finalForecast' : 'forecast'}
      placeholder={placeholder}
      onChange={handleChange}
      isError={isError}
      isWarning={isWarning}
      className="forecast-input"
    />
  );
};

export default ImpactForecast;
